module.exports = __webpack_public_path__ + "media/images/products/shop/7-8ae6e59840d9c35071b8455fa3f974ce.jpg";